import { useEffect, useRef } from 'react';

import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';

axios.defaults.withCredentials = true;

// Axios Custom - 즉시 주입 함수 표현식 (IIFE)
export const axiosCustom = (() => {
    // axios get
    async function axiosGet(url: string, config?: AxiosRequestConfig): Promise<any> {
        return axiosCommon(async () => await axios.get(url, config));
    }

    // axios post
    async function axiosPost(url: string, data?: any, config?: AxiosRequestConfig): Promise<any> {
        return axiosCommon(async () => await axios.post(url, data, config));
    }

    // axios delete
    async function axiosDelete(url: string, config?: AxiosRequestConfig): Promise<any> {
        return axiosCommon(async () => await axios.delete(url, config));
    }

    // axios 공통 처리 함수
    async function axiosCommon(axiosFunction: () => Promise<AxiosResponse>) {
        try {
            const { data: returnData } = await axiosFunction();

            return returnData;
        } catch (error: any) {
            let errorMessage = '';

            if (error.response?.data) {
                // 플토닷컴 response 형식
                if (error.response.data?.message) {
                    errorMessage = error.response.data.message;
                } else {
                    errorMessage = error.message;
                }
            } else {
                errorMessage = error.message;
            }
            throw new Error(errorMessage);
        }
    }

    return {
        get: axiosGet,
        post: axiosPost,
        delete: axiosDelete,
    };
})();

export const yyyymmdd = (dateTime: number) => {
    if (!dateTime) return '';

    const target = new Date(dateTime);

    function pad2(n: number) {
        // always returns a string
        return (n < 10 ? '0' : '') + n;
    }

    return `${target.getFullYear()}-${pad2(target.getMonth() + 1)}-${pad2(target.getDate())}  ${pad2(
        target.getHours(),
    )}:${pad2(target.getMinutes())}:${pad2(target.getSeconds())}`;
};

// json 파싱 재귀 함수
export const jsonParseRecursive = (target: any) => {
    target = JSON.parse(target);

    if (typeof target == 'string') {
        target = jsonParseRecursive(target);
    }

    return target;
};

// 숫자 제로 노출 함수 (ex: 001)
export const zeroPad = (nr: number, base: number) => {
    const len = String(base).length - String(nr).length + 1;
    return len > 0 ? new Array(len).join('0') + nr : nr;
};

//
export const useInterval = (callback: () => void, delay: number | null) => {
    const savedCallback = useRef<() => void | null>();
    // Remember the latest callback.
    useEffect(() => {
        savedCallback.current = callback;
    });
    // Set up the interval.
    useEffect(() => {
        function tick() {
            if (typeof savedCallback?.current !== 'undefined') {
                savedCallback?.current();
            }
        }
        if (delay !== null) {
            const id = setInterval(tick, delay);
            return () => clearInterval(id);
        }
    }, [delay]);
};

// 날짜포맷 yyyy-MM-dd 변환
export const getFormatDate = function (date: Date) {
    let year = date.getFullYear();
    let month: any = 1 + date.getMonth();
    month = month >= 10 ? month : '0' + month;
    let day: any = date.getDate();
    day = day >= 10 ? day : '0' + day;
    return year + '-' + month + '-' + day;
};

// 난수 생성 함수
export function random(digits: number) {
    if (digits <= 0) return 0;

    return Math.floor(Math.random() * [10, ...Array(digits - 1)].reduce((accumulator) => accumulator * 10));
}
